import { render } from "./EnglishLanguage.vue?vue&type=template&id=3f02fc3a"
import script from "./EnglishLanguage.vue?vue&type=script&lang=js"
export * from "./EnglishLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__